import { useContext } from 'react';
import ADSBContext from 'contexts/ADSBContext';
import MainAppContext from 'contexts/MainAppContext';
import AdsbProblemIcon from 'assets/icons/adsb_problem.svg';
import ViewModeMenu from './components/ViewModeMenu';
import styles from './index.module.scss';

const { wrapper, adsbProblemIcon } = styles;

function UtilsMenu() {
  const { realTimeMode } = useContext(MainAppContext);
  const { adsbConnectionError, pastAdsbMissing } = useContext(ADSBContext);

  const adsbProblemIconActive = (adsbConnectionError && realTimeMode)
    || (pastAdsbMissing && !realTimeMode);

  return (
    <div className={wrapper} id="utils-menu">
      <ViewModeMenu />
      {/* <span style={{
      backgroundColor: theme === 'dark' ? '#141414' : '#ffffff', borderRadius: '8px' }}>
        <Button
          type="default"
          onClick={() => setCrossSectionMode((prev) => !prev)}
          disabled={!activeProducts.length || viewMode === 'tile'}
          style={{ width: '100%' }}
        >
          <ScissorOutlined />
          {' Cross section'}
        </Button>
      </span> */}
      {adsbProblemIconActive && <img src={AdsbProblemIcon} className={adsbProblemIcon} alt="ADS-B Problem Icon" title="ADS-B data is missing." />}
    </div>
  );
}

export default UtilsMenu;
